/**
 * UTM Helper Component
 *
 */
"use strict";

export class UTM {
  constructor() {
    this.parameters = {};

    this.init();
  }

  /**
   * Initialize UTM parameters
   *
   */
  init() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Build parameters object
    this.parameters = {
      utm_source: urlParams.get("utm_source"),
      utm_medium: urlParams.get("utm_medium"),
      utm_campaign: urlParams.get("utm_campaign"),
      utm_term: urlParams.get("utm_term"),
      utm_content: urlParams.get("utm_content"),
      subId1: urlParams.get("subId1"),
      subId2: urlParams.get("subId2"),
      subId3: urlParams.get("subId3"),
      src: urlParams.get("src"),
      cid: urlParams.get("cid"),
      adid: urlParams.get("adid"),
      kw: urlParams.get("kw"),
      mt: urlParams.get("mt"),
      pmt: urlParams.get("pmt"),
      tgt: urlParams.get("tgt"),
      d: urlParams.get("d"),
      nw: urlParams.get("nw"),
      ext: urlParams.get("ext"),
      kwid: urlParams.get("kwid"),
    };

    // Remove null values
    for (const key in this.parameters) {
      if (this.parameters[key] === null) {
        delete this.parameters[key];
      }
    }
  }

  /**
   * Return UTM parameters
   *
   * @returns object
   */
  get_parameters() {
    return this.parameters;
  }
}
